/*
  Automatically instantiates modules based on data-attributes
  specifying module file-names.
*/

const moduleElements = document.querySelectorAll('[data-module]')

for (let i = 0; i < moduleElements.length; i++) {
  const el = moduleElements[i]
  const name = el.getAttribute('data-module')
  try {
    const Module = require(`./${name}`).default
    if (Module) {
      new Module(el)
    }
  } catch (error) {
    // If this is the first time seeing this error, reload once
    const reloadKey = `module-load-attempted-${name}`
    if (!sessionStorage.getItem(reloadKey)) {
      sessionStorage.setItem(reloadKey, 'true')
      window.location.reload()
    } else {
      console.warn(`Could not load module ${name}:`, error.message)
      el.removeAttribute('data-module')
    }
  }
}
